import { render, staticRenderFns } from "./SessionsTable.vue?vue&type=template&id=3c4c4691&"
import script from "./SessionsTable.vue?vue&type=script&lang=js&"
export * from "./SessionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/musili/musilidev/webroot/work-bmm/01_DEX/dex/front-end/web-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4c4691')) {
      api.createRecord('3c4c4691', component.options)
    } else {
      api.reload('3c4c4691', component.options)
    }
    module.hot.accept("./SessionsTable.vue?vue&type=template&id=3c4c4691&", function () {
      api.rerender('3c4c4691', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenant_customer/views/Dashboard/Components/SessionsTable.vue"
export default component.exports